export const reportsConstants = {
  // Liste Prezencat
  approvals: {
    title: "Listë Prezencat",
    subTitle: "Info rreth turneve",
    note: "",
    columnDefs: [
      // "employeeFirstName",
      // "employeeLastName",
      "employee",
      "employeeDepartmentName",
      "clockDate",
      "clockInDate",
      "clockOutDate",
      // "employeeFullName",
      // "clockInPayment",
      // "clockInRate",
      "before19",
      "between19and22",
      "after22",
      "duration",
      "breakHours",
      "durationWithBreak",
      "dayType",
      "breakTime",
      "breakTimeVal",
      "employeeTeam",
      "clockInNote",
      "clockOutNote",
    ],
    allAppliedColumnDefs: [
      "clockInDate",
      "clockOutDate",
      "clockDate",
      "employeeFirstName",
      "employeeLastName",
      "employeeDepartmentName",
      "approved",
      "clockInNote",
      "clockOutNote",
      "duration",
      "breakHours",
      "durationWithBreak",
      "employeeFullName",
      "clockInPayment",
      "clockInRate",
      "before19",
      "between19and22",
      "after22",
      "employee",
      "dayType",
      "breakTime",
      "breakTimeVal",
      //
      "employeeId",
      "employeeGender",
      "employeeDayOfBirth",
      "employeeSupervisor",
      "employeeEmailWork",
      "employeeEmailPersonal",
      "employeePhoneWork",
      "employeePhonePersonal",
      "employeeAddress",
      "employeeCity",
      "employeeCountry",
      "employeeZipCode",
      "employeePosition",
      // "employeeStartDate",
      "employeeHireDate",
      "employeeEndDate",
      "employeeStatus",
      "employeeReasonforTermination",
      "employeeTypeOfEmployment",
      "employeeTypeOfContract",
      "employeeTypeOfContractDescription",
      "employeeTypeOfContractStartDate",
      "employeeTypeOfContractEndDate",
      "employeeTypeOfContractSalary",
      "employeeSalaryPerHour",
      "employeeMonthlyNetSalary",
      "employeeGrossMonthlySalary",
      "employeeTeam",
    ],
  },
  supervisorApprovals: {
    title: "Listë Prezencat",
    subTitle: "Info rreth turneve",
    note: "",
    columnDefs: [
      // "employee",
      "employee",
      "employeeDepartmentName",
      "clockDate",
      "clockInDate",
      "clockOutDate",
      // "employeeFullName",
      // "clockInPayment",
      // "clockInRate",
      "before19",
      "between19and22",
      "after22",
      "duration",
      "breakHours",
      "durationWithBreak",
      "dayType",
      "breakTime",
      // "employeeFullName",
      // "employeeDepartmentName",
      // "clockInPayment",
      // "clockInRate",
      // "duration",
      // "dayType",
      "employeeTeam",
    ],
    allAppliedColumnDefs: [
      "clockInDate",
      "clockOutDate",
      "clockDate",
      "employeeFirstName",
      "employeeLastName",
      "employeeDepartmentName",
      "approved",
      "clockInNote",
      "clockOutNote",
      "duration",
      "breakHours",
      "durationWithBreak",
      "employeeFullName",
      "employee",

      // "clockInPayment",
      // "clockInRate",
      //
      "before19",
      "between19and22",
      "after22",
      // "duration",
      "dayType",
      "employeeId",
      "employeeGender",
      "employeeDayOfBirth",
      "employeeSupervisor",
      "employeeEmailWork",
      "employeeEmailPersonal",
      "employeePhoneWork",
      "employeePhonePersonal",
      "employeeAddress",
      "employeeCity",
      "employeeCountry",
      "employeeZipCode",
      "employeePosition",
      "employeeStartDate",
      "employeeEndDate",
      "employeeStatus",
      "employeeReasonforTermination",
      "employeeTypeOfEmployment",
      "employeeTypeOfContract",
      // "employeeTypeOfContractDescription",
      "employeeTypeOfContractStartDate",
      "employeeTypeOfContractEndDate",
      "breakTime",
      // "employeeTypeOfContractSalary",
      // "employeeSalaryPerHour",
      // "employeeMonthlyNetSalary",
      // "employeeGrossMonthlySalary",
      "employeeTeam",
    ],
  },
  clockingTypesReports: {
    title: "Listë Prezencat",
    subTitle: "Info rreth turneve",
    note: "",
    columnDefs: [
      // "employee",
      "employee",
      "employeeDepartmentName",
      "employeeTeam",
      "regularDays",
      "sickDays",
      "holidayRequestDays",
      "nationalHolidayDays",
      "nationalHolidayWorkedDays",
      "maternityDays",
      "missingDays",

      /////////////////////////

      /////////////////////////,

      // "employeeDepartmentName",
      // "clockDate",
      // "clockInDate",
      // "clockOutDate",
      // "employeeFullName",
      // "clockInPayment",
      // "clockInRate",
      // "before19",
      // "between19and22",
      // "after22",
      // "duration",
      // "dayType",
      // "breakTime",
      // "employeeFullName",
      // "employeeDepartmentName",
      // "clockInPayment",
      // "clockInRate",
      // "duration",
      // "dayType",
      // "employeeTeam",
    ],
    allAppliedColumnDefs: [
      "regularDays",
      "sickDays",
      "holidayRequestDays",
      "nationalHolidayDays",
      "nationalHolidayWorkedDays",
      "maternityDays",
      "missingDays",
      "clockInDate",
      "clockOutDate",
      "clockDate",
      "employeeFirstName",
      "employeeLastName",
      "employeeDepartmentName",
      "approved",
      "clockInNote",
      "clockOutNote",
      "duration",
      "employeeFullName",
      "employee",

      // "clockInPayment",
      // "clockInRate",
      //
      // "before19",
      // "between19and22",
      // "after22",
      // "duration",
      "dayType",
      "employeeId",
      "employeeGender",
      "employeeDayOfBirth",
      "employeeSupervisor",
      "employeeEmailWork",
      "employeeEmailPersonal",
      "employeePhoneWork",
      "employeePhonePersonal",
      "employeeAddress",
      "employeeCity",
      "employeeCountry",
      "employeeZipCode",
      "employeePosition",
      "employeeStartDate",
      "employeeEndDate",
      "employeeStatus",
      "employeeReasonforTermination",
      "employeeTypeOfEmployment",
      "employeeTypeOfContract",
      // "employeeTypeOfContractDescription",
      "employeeTypeOfContractStartDate",
      "employeeTypeOfContractEndDate",
      "breakTime",
      // "employeeTypeOfContractSalary",
      // "employeeSalaryPerHour",
      // "employeeMonthlyNetSalary",
      // "employeeGrossMonthlySalary",
      "employeeTeam",
    ],
  },

  // Employee Requests
  requests: {
    title: "Regjistri i kërkesave",
    subTitle: "Vjetore/personale",
    note: "",
    columnDefs: [
      "employeeFirstName",
      "employeeLastName",
      "requestType",
      "requestStart",
      "requestEnd",
      "employeeDepartmentName",
      "requestStatus",
      "employeeTeam",
    ],
    allAppliedColumnDefs: [
      "requestType",
      "requestStart",
      "requestEnd",
      "createdAt",
      "requestStatus",
      "requestDescription",
      //
      "employeeId",
      "employeeFirstName",
      "employeeLastName",
      "employeeDepartmentName",
      "employeeGender",
      "employeeDayOfBirth",
      "employeeSupervisor",
      "employeeEmailWork",
      "employeeEmailPersonal",
      "employeePhoneWork",
      "employeePhonePersonal",
      "employeeAddress",
      "employeeCity",
      "employeeCountry",
      "employeeZipCode",
      "employeePosition",
      // "employeeStartDate",
      "employeeHireDate",
      "employeeEndDate",
      "employeeStatus",
      "employeeReasonforTermination",
      "employeeTypeOfEmployment",
      "employeeTypeOfContract",
      "employeeTypeOfContractDescription",
      "employeeTypeOfContractStartDate",
      "employeeTypeOfContractEndDate",
      "employeeTypeOfContractSalary",
      // "employeeSalaryPerHour",
      // "employeeMonthlyNetSalary",
      // "employeeGrossMonthlySalary",
      "employeeTeam",
    ],
  },
  // Payments from table wages
  bankForwardPay: {
    title: "Listëpagesa për në bankë",
    subTitle: "Të dhëna financiare",
    note: "",
    columnDefs: [
      "idNumber",
      "employeeFirstName",
      "employeeLastName",
      "timeframe",
      "totalBruto",
      "totalNeto",
      "totalIns",
      "totalEmployeeerIns",
      "bankTotal",
      "total",
      "employeeTeam",
    ],
    allAppliedColumnDefs: [
      "idNumber",
      "employeeFirstName",
      "employeeLastName",
      "timeframe",
      "totalBruto",
      "totalNeto",
      "totalIns",
      "totalEmployeeerIns",
      "bankTotal",
      "total",
      "employeeTeam",
    ],
  },

  // Additions and Deductions
  prepayments: {
    title: "Orë shtesë/Banka e Orëve/Kompensime",
    subTitle: "Të dhëna financiare",
    note: "",
    columnDefs: [
      "employeeFirstName",
      "employeeLastName",
      "additions",
      "deductions",
      "timeframe",
      "employeeDepartmentName",
      "total",
      "employeeTeam",
    ],
    allAppliedColumnDefs: [
      "additions",
      "deductions",
      "timeframe",
      "total",
      //
      "employeeId",
      "employeeFirstName",
      "employeeLastName",
      "employeeDepartmentName",
      "employeeGender",
      "employeeDayOfBirth",
      "employeeSupervisor",
      "employeeEmailWork",
      "employeeEmailPersonal",
      "employeePhoneWork",
      "employeePhonePersonal",
      "employeeAddress",
      "employeeCity",
      "employeeCountry",
      "employeeZipCode",
      "employeePosition",
      "employeeStartDate",
      "employeeEndDate",
      "employeeStatus",
      "employeeReasonforTermination",
      "employeeTypeOfEmployment",
      "employeeTypeOfContract",
      "employeeTypeOfContractDescription",
      "employeeTypeOfContractStartDate",
      "employeeTypeOfContractEndDate",
      "employeeTypeOfContractSalary",
      "employeeSalaryPerHour",
      "employeeMonthlyNetSalary",
      "employeeGrossMonthlySalary",
      "employeeTeam",
    ],
  },

  // Detailed Taxes
  detailedTaxes: {
    title: "Listëpagesa e Kontributeve dhe TAP",
    subTitle: "Të dhëna financiare",
    note: "",
    columnDefs: [
      "idNumber",
      "employeeFirstName",
      "employeeLastName",
      "employeeDepartmentName",
      "totalBruto",
      "totalNeto",
      "healthIns",
      "socialIns",
      "progressiveTax",
      "totalIns",
      "healthInsEmployeer",
      "insuranceEmployeer",
      "total",
      "employeeTeam",
    ],
    allAppliedColumnDefs: [
      "idNumber",
      "employeeFirstName",
      "employeeLastName",
      "employeeDepartmentName",
      "totalBruto",
      "totalNeto",
      "healthIns",
      "socialIns",
      "progressiveTax",
      "totalIns",
      "healthInsEmployeer",
      "insuranceEmployeer",
      "total",
      "employeeGender",
      "employeeDayOfBirth",
      "employeeSupervisor",
      "employeeEmailWork",
      "employeeEmailPersonal",
      "employeePhoneWork",
      "employeePhonePersonal",
      "employeeAddress",
      "employeeCity",
      "employeeCountry",
      "employeeZipCode",
      "employeeDepartmentName",
      "employeePosition",
      "employeeStartDate",
      "employeeEndDate",
      "employeeStatus",
      "employeeReasonforTermination",
      "employeeTypeOfEmployment",
      "employeeTypeOfContract",
      "employeeTypeOfContractDescription",
      "employeeTypeOfContractStartDate",
      "employeeTypeOfContractEndDate",
      "employeeTypeOfContractSalary",
      "employeeSalaryPerHour",
      "employeeMonthlyNetSalary",
      "employeeGrossMonthlySalary",
      "employeeTeam",
    ],
  },

  employeesList: {
    title: "Lista e punonjësve",
    subTitle: "Të dhëna kompanie",
    columnDefs: [
      "employeeFirstName",
      "employeeLastName",
      "employeeAddress",
      "employeeDepartmentName",
      "employeeEmailWork",
      "employeeTeam",

      // "employeePersonalEmail",
      // "employeePhoneNumber",
    ],
    allAppliedColumnDefs: [
      "employeeId",
      "employeeFirstName",
      "employeeLastName",
      "employeeGender",
      "employeeDayOfBirth",
      "employeeSupervisor",
      "employeeEmailWork",
      // "employeeEmailPersonal",
      "employeePersonalEmail",
      "employeePhoneNumber",
      "employeePhoneWork",
      "employeePhonePersonal",
      "employeeAddress",
      "employeeCity",
      "employeeCountry",
      "employeeZipCode",
      "employeeDepartmentName",
      "employeePosition",
      // "employeeStartDate",
      "employeeHireDate",
      "employeeEndDate",
      "employeeStatus",
      "employeeReasonforTermination",
      "employeeTypeOfEmployment",
      "employeeTypeOfContract",
      "employeeTypeOfContractDescription",
      "employeeTypeOfContractStartDate",
      "employeeTypeOfContractEndDate",
      "employeeTypeOfContractSalary",
      "employeeSalaryPerHour",
      "employeeMonthlyNetSalary",
      "employeeGrossMonthlySalary",
      "employeeTeam",
    ],
    note: "",
  },

  employeesLeave: {
    title: "Lejet e punonjësve",
    subTitle: "Të dhëna kompanie",
    columnDefs: [
      "employeeFullName",
      "dayType",
      "approved",
      "createdAt",
      "clockDate",
      "clockInDate",
      "clockOutDate",
      "durationWithBreak",
      
      // "employeePersonalEmail",
      // "employeePhoneNumber",
    ],
    allAppliedColumnDefs: [
      "employeeFullName",
      "approved",
      "clockInDate",
      "clockInNote",
      "clockOutDate",
      "durationWithBreak",
      "clockOutNote",
      "createdAt",
      "clockDate",
      "dayType",
      "employeeSupervisor",
      "employeeDepartmentName",
      "employeePosition",
      "employeeHireDate",
      "employeeStatus",
      "employeeTeam",
    ],
    note: "",
  },

  // Trendi i punesimeve dhe largimeve!
  suspensions: {
    title: "Trendi i punësimeve dhe largimeve",
    subTitle: "Të dhëna kompanie",
    columnDefs: [
      "employeeFirstName",
      "employeeLastName",
      "employeeAddress",
      "employeeDepartmentName",
      "employeeEmailWork",
      "employeeStatus",
      "employeeLatestStatusUpdate",
      "employeeTeam",
    ],
    allAppliedColumnDefs: [
      "employeeFirstName",
      "employeeLastName",
      "employeeAddress",
      "employeeDepartmentName",
      "employeeEmailWork",
      "employeeStatus",
      "employeeLatestStatusUpdate",
      "employeeTeam",
    ],
  },

  openForgottenShifts: {
    title: "Turne të hapura / të harruara",
    subTitle: "Prezenca operacionale",
    note: "",
    columnDefs: [
      "employee",
      "employeeDepartmentName",
      "employeeTeam",
      "clockDate",
      "clockInDate",
      "clockOutDate",
      "shiftStatus",
      "forgotClockOut",
      "ageHours",
      "approved",
    ],
    allAppliedColumnDefs: [
      "employee",
      "employeeDepartmentName",
      "employeeTeam",
      "clockDate",
      "clockInDate",
      "clockOutDate",
      "shiftStatus",
      "forgotClockOut",
      "ageHours",
      "approved",
      "clockInNote",
    ],
  },

  missingPunches: {
    title: "Mungesa / pa prezencë",
    subTitle: "Ditë pune pa clock-in",
    note: "",
    columnDefs: [
      "employee",
      "employeeDepartmentName",
      "employeeTeam",
      "missingDate",
      "dayName",
      "dayType",
    ],
    allAppliedColumnDefs: [
      "employee",
      "employeeDepartmentName",
      "employeeTeam",
      "missingDate",
      "dayName",
      "dayType",
      "employeeEmailWork",
      "employeeStatus",
    ],
  },

  otBank: {
    title: "Banka e orëve shtesë",
    subTitle: "19–22 / pas 22 / fundjavë",
    note: "",
    columnDefs: [
      "employee",
      "employeeDepartmentName",
      "employeeTeam",
      "between19and22",
      "after22",
      "weekendHours",
      "totalOt",
      "shiftCount",
    ],
    allAppliedColumnDefs: [
      "employee",
      "employeeDepartmentName",
      "employeeTeam",
      "between19and22",
      "after22",
      "weekendHours",
      "totalOt",
      "shiftCount",
    ],
  },

  hoursCostByDept: {
    title: "Kosto orësh sipas departamentit",
    subTitle: "Orë × tarifë / pagesë turni",
    note: "",
    columnDefs: [
      "employee",
      "employeeDepartmentName",
      "employeeTeam",
      "before19",
      "between19and22",
      "after22",
      "totalHours",
      "employeeRate",
      "estimatedCost",
    ],
    allAppliedColumnDefs: [
      "employee",
      "employeeDepartmentName",
      "employeeTeam",
      "before19",
      "between19and22",
      "after22",
      "totalHours",
      "employeeRate",
      "estimatedCost",
    ],
  },

  plannedVsActual: {
    title: "Planifikuar vs aktual",
    subTitle: "Orë turni të planifikuara kundrejt të punuara",
    note: "",
    columnDefs: [
      "employee",
      "employeeDepartmentName",
      "employeeTeam",
      "shiftName",
      "plannedHours",
      "actualHours",
      "varianceHours",
      "variancePct",
    ],
    allAppliedColumnDefs: [
      "employee",
      "employeeDepartmentName",
      "employeeTeam",
      "shiftName",
      "plannedHours",
      "actualHours",
      "varianceHours",
      "variancePct",
    ],
  },

  leaveBalance: {
    title: "Bilanci i lejeve",
    subTitle: "Përdorimi i lejeve në periudhë",
    note: "",
    columnDefs: [
      "employee",
      "employeeDepartmentName",
      "employeeTeam",
      "requestType",
      "entitledDays",
      "usedDays",
      "remainingDays",
    ],
    allAppliedColumnDefs: [
      "employee",
      "employeeDepartmentName",
      "employeeTeam",
      "requestType",
      "entitledDays",
      "usedDays",
      "remainingDays",
    ],
  },

  leaveCoverage: {
    title: "Mbulimi i lejeve",
    subTitle: "Kush mungon sipas ditës",
    note: "",
    columnDefs: [
      "leaveDate",
      "dayName",
      "employee",
      "employeeDepartmentName",
      "employeeTeam",
      "requestType",
      "requestStatus",
    ],
    allAppliedColumnDefs: [
      "leaveDate",
      "dayName",
      "employee",
      "employeeDepartmentName",
      "employeeTeam",
      "requestType",
      "requestStatus",
    ],
  },
};
